// extracted by mini-css-extract-plugin
export default {"btn__wrapper":"Requests_btn__wrapper__Gzc4I"};